<template>
  <!-- BOUTON DECONNECTER -->
  <ApplicationHeaderLink
    id="applicationConnector__mobile"
    :buttonConfig="computedConfig"
    @click.native="$emit('connect')"
  />
</template>

<script>
import ApplicationHeaderLink from "./ApplicationHeaderLink";

export default {
  name: "ConnectLink",
  props: {
    connectConfig: { type: Object, default: () => {} }
  },
  computed: {
    computedConfig() {
      return Object.assign({}, this.connectConfig, {
        action: "connect",
        iconName: "dgfipicon-cadenas-ferme",
        text: "Connectez-vous"
      });
    }
  },
  components: {
    ApplicationHeaderLink
  }
};
</script>